module.exports = (component, listener, handler, applicationCodeZone) =>
  component[listener](applicationCodeZone(handler))
